import { config, passport } from '@imtbl/sdk';
import {
  IS_PRODUCTION,
  IMX_PUB_KEY,
  IMX_CLIENT_ID
} from '../constants';
import { convertUrl } from './';

const passportInstance = new passport.Passport({
  baseConfig: {
    environment: IS_PRODUCTION ? config.Environment.PRODUCTION : config.Environment.SANDBOX,
    publishableKey: IMX_PUB_KEY,
  },
  clientId: IMX_CLIENT_ID,
  redirectUri: convertUrl('/passport'),
  logoutRedirectUri: convertUrl('/home'),
  audience: 'platform_api',
  scope: 'openid offline_access email transact',
});

export default passportInstance;
